module.exports = __webpack_public_path__ + "static/media/arborea5.8cbd181d.webp";